import { CommonModule } from '@angular/common';
import { Component, Renderer2 } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NotificationsPanelComponent } from 'app/notification/notifications-panel.component';
import { NotificationPanelService } from 'app/notification/notifications-panel.service';
import { ImpersonateInfoComponent } from 'app/profile/impersonate-user/impersonate-info/impersonate-info.component';
import { ImpersonateService } from 'app/profile/impersonate-user/impersonate.service';
import { ChatPanelComponent } from 'app/shared/components/chat-panel/chat-panel.component';
import { ToastTypesEnum } from 'app/shared/enums/toast.enum';
import { IActiveChat } from 'app/shared/models/chat.model';
import { ChatService } from 'app/shared/services/chat.service';
import { SignalRService, SIGNAL_R_LISTENERS } from 'app/shared/services/signalr.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, NotificationsPanelComponent, ChatPanelComponent, CommonModule, TranslateModule, ImpersonateInfoComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isNotificationPanelOpen = false;
  isChatPanelOpen = false;
  unreadCount = 0;

  constructor(
    private notificationService: NotificationPanelService,
    private signalR: SignalRService,
    public chatService: ChatService,
    public impersonateService: ImpersonateService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private renderer: Renderer2
  ) {

  }

  ngOnInit(): void {
    this.notificationService.unreadCount$.subscribe((count) => {
      this.unreadCount = count;
    });
    this.signalR.listenToChatNotificationsEvent<any>(SIGNAL_R_LISTENERS.ChatHubAddActiveRoomNotification).subscribe((resp: IActiveChat[]) => {
      this.chatService.activeChats.push(...resp);
      this.chatService.openChat.next(resp[0]);
      if (resp.length) {
        this.toastr.show(
          this.translate.instant('label.chat.new_chat_active_message'), ToastTypesEnum.INFO
        );
      }
    });
    this.signalR.listenToChatNotificationsEvent<any>(SIGNAL_R_LISTENERS.ChatHubDeleteActiveRoomNotification).subscribe((resp: IActiveChat[]) => {
      this.chatService.activeChats = this.chatService.activeChats.filter(chat => chat.chatRoomName !== resp[0].chatRoomName);
      this.toastr.show(
        this.translate.instant('label.chat.chat_saved_in_comments_message', { chatRoom: resp[0].chatRoomName }), ToastTypesEnum.INFO
      );
      this.chatService.disableChat.next(resp[0]);
    });

    this.signalR.startChatNotificationsConnection().subscribe(() => { });
    this.signalR.startCaseLockingConnection().subscribe(() => { });
  }

  stopImpersonation(): void {
    this.impersonateService.stopImpersonation();
  }

  toggleNotificationsPanel(): void {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
    this.isNotificationPanelOpen ? this.renderer.addClass(document.body, 'no-scroll') : this.renderer.removeClass(document.body, 'no-scroll');
    this.isChatPanelOpen = false;
  }

  toggleChatPanel(): void {
    this.isChatPanelOpen = !this.isChatPanelOpen;
    this.isNotificationPanelOpen = false;
  }

  closeNotificationsPanel(): void {
    this.isNotificationPanelOpen = false;
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  closeChatPanel(): void {
    this.isChatPanelOpen = false;
  }
}
